/**
 * @generated SignedSource<<c8ac78d36e8ac1d9ba43e99308b9c85d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewDisplayMode = "MEDIUM" | "MEDIUM_GROUPED";
export type WidgetTodoOverviewUpdateInput = {
  setCategoryId?: string | null;
  setDisplayMode?: WidgetTodoOverviewDisplayMode | null;
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSTodoOverviewMutation$variables = {
  storecastId: string;
  update: WidgetTodoOverviewUpdateInput;
  widgetId: string;
};
export type WSTodoOverviewMutation$data = {
  readonly dashboard: {
    readonly updateWidgetTodoOverview: {
      readonly displayMode: WidgetTodoOverviewDisplayMode;
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverview_widget">;
    };
  };
};
export type WSTodoOverviewMutation = {
  response: WSTodoOverviewMutation$data;
  variables: WSTodoOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  },
  {
    "kind": "Variable",
    "name": "update",
    "variableName": "update"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayMode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTodoOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetTodoOverview",
            "kind": "LinkedField",
            "name": "updateWidgetTodoOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTodoOverview_widget"
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSTodoOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetTodoOverview",
            "kind": "LinkedField",
            "name": "updateWidgetTodoOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "myRole",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integration",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "beb23518cd6effce9456ff28ee2d94b9",
    "id": null,
    "metadata": {},
    "name": "WSTodoOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WSTodoOverviewMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $update: WidgetTodoOverviewUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetTodoOverview(id: $widgetId, update: $update) {\n      id\n      ...WidgetTodoOverview_widget\n      displayMode\n      teams {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment WidgetTodoOverview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    store {\n      myRole\n      id\n    }\n    id\n    title\n    integration\n  }\n  teams {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fac85ee4b01e65d24f356eac366405cd";

export default node;
